module.exports = __webpack_public_path__ + "/img/SODFL-1169tW.svg";